import React from 'react';
import { TOKENS } from '../styles';

interface Props {
  label: string;
  value: string;
}

export default function MetricTile({ label, value }: Props) {
  return (
    <div style={{
      background: TOKENS.card,
      border: '1px solid ' + TOKENS.line,
      borderRadius: 12,
      padding: '16px 18px',
    }}>
      <div style={{ fontSize: 13, color: TOKENS.dark, fontWeight: 600 }}>{label}</div>
      <div style={{
        fontSize: 26,
        fontWeight: 700,
        marginTop: 3,
        color: TOKENS.ink,
        fontVariantNumeric: 'tabular-nums',
      }}>
        {value}
      </div>
    </div>
  );
}